import { render } from "./PermissionRolesPage.vue?vue&type=template&id=5b2b4eed&scoped=true"
import script from "./PermissionRolesPage.vue?vue&type=script&lang=js"
export * from "./PermissionRolesPage.vue?vue&type=script&lang=js"

import "./PermissionRolesPage.vue?vue&type=style&index=0&id=5b2b4eed&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b2b4eed"]])

export default __exports__